import { render } from "./FinalPreview.vue?vue&type=template&id=dada7db6&ts=true"
import script from "./FinalPreview.vue?vue&type=script&lang=ts"
export * from "./FinalPreview.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__